

// import { useMutation } from "@tanstack/react-query";
// import {
//     AddCustomerForInsuranceRemember,
//     CreateCustomerForStreetCard,
// } from "./api.js";
// import type { AddCustomerForInsuranceRememberPayload } from "./types.js";



// export const useAddCustomerForInsuranceRemember = () => {
//     return useMutation({
//         mutationFn: (payload: AddCustomerForInsuranceRememberPayload) =>
//             AddCustomerForInsuranceRemember(payload),
//     });
// };

// export const useCreateCustomerForStreetCard = () => {
//     return useMutation({
//         mutationFn: (data: any) => CreateCustomerForStreetCard(data)
//     })
// }

import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  AddCustomerForInsuranceRemember,
  CreateCustomerForStreetCard,
  RequestRegisterLegal,
  RequestRegisterCharity,
  SetDefaultPlanForVisitorApi,
  SetDefaultPlanVisitorApi,
} from "./api.js";
import type { AddCustomerForInsuranceRememberPayload } from "./types.js";

export const useAddCustomerForInsuranceRemember = () => {
  return useMutation({
    mutationFn: (payload: AddCustomerForInsuranceRememberPayload) =>
      AddCustomerForInsuranceRemember(payload),
  });
};

export const useCreateCustomerForStreetCard = () => {
  return useMutation({
    mutationFn: (data: any) => CreateCustomerForStreetCard(data),
  });
};

// ============================================================
// ⭐ جدید: هوک ثبت نام حقوقی
// ============================================================
export const useRequestRegisterLegal = () => {
  return useMutation({
    mutationFn: (payload: any) => RequestRegisterLegal(payload),
  });
};
import { setShebaCustomer } from "./api.js";
import { authKeys } from "../../auth/key.js";

export const useSetShebaCustomer = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: {
      shebaNumber: string;
    }) => setShebaCustomer(data),
    onSuccess: () => {
      // آپدیت اطلاعات کاربر
      queryClient.invalidateQueries({
        queryKey: authKeys.userInfo(),
      });
    },
  });
};
// ============================================================
// ⭐ جدید: هوک ثبت نام خیریه
// ============================================================
export const useRequestRegisterCharity = () => {
  return useMutation({
    mutationFn: (payload: any) => RequestRegisterCharity(payload),
  });
};




export const useSetDefaultPlanForVisitor = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: { planId: number }) =>
      SetDefaultPlanForVisitorApi(params.planId),
    onSuccess: () => {
      // ✅ لیست طرح‌ها رو دوباره بگیر
      queryClient.invalidateQueries({
        queryKey: ["GetPlaneCustomerTest"],
      });
      queryClient.invalidateQueries({
        queryKey: ["GetPlaneCustomer"],
      });
    },
  });
};


export const useSetDefaultPlanVisitor = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: { planId: number }) =>
      SetDefaultPlanVisitorApi(params.planId),
    onSuccess: () => {
      // ✅ لیست طرح‌ها رو دوباره بگیر
      queryClient.invalidateQueries({
        queryKey: ["GetPlaneCustomerTest"],
      });
      queryClient.invalidateQueries({
        queryKey: ["GetPlaneCustomer"],
      });
    },
  });
};

import { ChangePlanForCustomer } from "./api.js";
import { GetPlanForCustomerKey } from "./key.js";

// ============================================================
// ✅ تغییر طرح‌های یک مشتری
// ============================================================
export const useChangePlanForCustomer = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: {
      customerId: number;
      streetPlanId1: number;
      streetPlanId2?: number;
      streetPlanId3?: number;
    }) => ChangePlanForCustomer(payload),
    onSuccess: (_, variables) => {
      // ✅ رفرش طرح‌های مشتری
      queryClient.invalidateQueries({
        queryKey: GetPlanForCustomerKey(variables.customerId),
      });
    },
  });
};

import { ImportCustomerWithExcel } from "./api.js";
import { CustomerList } from "../../admins/customer/key.js"; // یا هر کی‌ای که لیست مشتری رو invalidate می‌کنه

interface ImportPayload {
    file: File;
    streetPlanId1: number;
    streetPlanId2?: number | null;
    streetPlanId3?: number | null;
}

export const useImportCustomerWithExcel = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({
            file,
            streetPlanId1,
            streetPlanId2,
            streetPlanId3,  
        }: any) =>
            ImportCustomerWithExcel(
                file,
                streetPlanId1,
                streetPlanId2,
                streetPlanId3
            ),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: CustomerList() });
        },
    });
};